.modalWrapper {
  width: 650px;
}
.modalBody {
  /* needed or the aha-modal-footer disappears off the bottom when there's a scrollbar */
  max-height: calc(90vh - 170px);
  margin: 0;
  overflow: auto;
}

.tabHeader {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--theme-primary-border);
  padding-top: var(--spacer-1);
}
.tabHeader .issueCount {
  color: var(--theme-secondary-text);
  padding: 0 var(--spacer-4) 2px;
  margin-left: auto;
}

.warningMessage {
  width: 450px;
  height: 50px;

  /* negative margin to avoid a big gap before .formWrapper */
  margin: var(--spacer-4) auto -34px;
}

.formWrapper {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: var(--spacer-4) var(--spacer-4);
  margin: 50px; /* note the negative margin on .warningMessage that interacts with this */
}
.formRow {
  display: contents;
}
.formRowLabel,
.formRow > .spacer {
  text-align: right;
  padding: var(--spacer-1) 0;
  /* width: 100px; */
  font-size: var(--font-size-050);
  flex: 1;
}
.formRow.required .formRowLabel::after {
  content: '*';
  color: var(--theme-red-text);
}
.formRowContent {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-1);
  flex: 2;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
